// src/utils/twilioDevice.js
let DeviceClass = null
let pending = null

export async function getTwilioDeviceClass() {
  if (DeviceClass) return DeviceClass
  if (pending) return pending

  pending = import('@twilio/voice-sdk')
    .then(mod => {
      const Device = mod?.Device || mod?.default?.Device || mod
      if (!Device) {
        throw new Error('Failed to load Twilio Voice SDK Device class')
      }
      DeviceClass = Device
      return DeviceClass
    })
    .finally(() => {
      pending = null
    })

  return pending
}
